import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ConditionalRender from '../../../components/ConditionalRender';
import {
  getRegisteredTimeSlotAndState,
  getSelectedEvent,
  useAppContext,
} from '../../../contextProviders/AppContext';
import { TimeSlot } from '../../../types/model';
import { formatEventTimeSpan } from '../../../utils/formatDate';
import getCaption from './getCaption';
import { isPassedTimeSlot } from '../../../contextProviders/AppContext/utils';
import IconPill from '@ingka/pill';
import CalendarCancelIcon from '@ingka/ssr-icon/paths/calendar-cancel';

type PropsType = {
  timeslots: Array<TimeSlot>;
  timeZone: string;
  registrationRequired: boolean;
};

const Timeslot = styled.div`
  border: 2px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: bold;
  padding: 1.25rem 1.5rem;
`;

const Timeslots = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
  row-gap: 1rem;
  min-height: 85px;
`;

const Label = styled.p`
  font-weight: normal;
`;

const BasicItems = (props: PropsType) => {
  const { timeslots, registrationRequired } = props;
  const { t } = useTranslation();
  const { useSelector } = useAppContext();
  const [registeredToTimeSlot, registrationState] = useSelector(
    getRegisteredTimeSlotAndState
  );

  const selectedEvent = useSelector(getSelectedEvent);
  const allowMultipleRegistrations = selectedEvent?.allowMultipleRegistrations ?? false;

  return (
    <ConditionalRender predicate={timeslots.length > 0}>
      <Timeslots>
        {timeslots.map((timeSlot: TimeSlot, i: number) => {
          return (
            <Timeslot key={i} style={{color: isPassedTimeSlot(timeSlot) ? '#595959' : undefined}}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {isPassedTimeSlot(timeSlot) && (
                  <IconPill
                    aria-label={t('event.passed')}
                    x-small={true}
                    ssrIcon={CalendarCancelIcon}
                    style={{
                      width: 'fit-content',
                      marginLeft: '-18px',
                      paddingLeft: '10px',
                      paddingRight: '3px',
                      minHeight: '45px',
                      color: '#595959',
                    }}
                  />
                )}
                {formatEventTimeSpan(
                  timeSlot.utcStartDate,
                  timeSlot.utcEndDate,
                  timeSlot.startDate,
                  timeSlot.endDate,
                  props.timeZone
                )}
              </div>

              <ConditionalRender predicate={registrationRequired}>
                <Label
                  style={{
                    marginLeft: isPassedTimeSlot(timeSlot) ? '30px' : undefined,
                  }}
                >
                  {getCaption(
                    timeSlot,
                    registeredToTimeSlot,
                    registrationState,
                    t,
                    allowMultipleRegistrations
                  )}
                </Label>
              </ConditionalRender>
            </Timeslot>
          );
        })}
      </Timeslots>
    </ConditionalRender>
  );
};

export default BasicItems;
